export default "__VITE_ASSET__laq$wNfq__"